import { inject } from '@angular/core';
import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/client-services/loading.service';

export const SKIP_LOADING = new HttpContextToken<boolean>(() => false);

export const httpLoadingInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_LOADING)) {
    return next(req);
  }

  const loader = inject(LoadingService);
  loader.start();
  return next(req).pipe(
    finalize(() => loader.stop())
  );
};
